import React, { useEffect, useState } from 'react';
import { Entity } from '@backstage/catalog-model';
import { TechRadarComponent, TechRadarPageProps} from '@backstage-community/plugin-tech-radar';
import { Select, MenuItem, FormControl, InputLabel, Grid, Input, makeStyles } from '@material-ui/core';
import {
  Content,
  ContentHeader,
  Header,
  Page,
  SupportButton,
} from '@backstage/core-components';
import { useApi} from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';

const useStyles = makeStyles(() => ({
  overflowXScroll: {
    overflowX: 'scroll',
  },
}));

const TechRadarCustomPage = (props: TechRadarPageProps) => {
  const catalogApi = useApi(catalogApiRef);
  
  useEffect(() => {
    const fetchDomains = async () => {
      const response = await catalogApi.getEntities({
        filter: { kind: 'Domain' },
      });
      setDomains(response.items);
    };

    fetchDomains();
  }, [catalogApi]);

  
  const [domains, setDomains] = useState<Entity[]>([]);
  const [radarId, setRadarId] = useState('Tranzact');
  const {
    title = 'Tech Radar',
    subtitle = 'Pick the recommended technologies for your projects',
    pageTitle = 'Company Radar',
    ...componentProps
  } = props;
  const classes = useStyles();
  const [searchText, setSearchText] = React.useState('');

  return (
    <>
    <Page themeId="tool">
      <Header title={title} subtitle={subtitle} />
      <Content className={classes.overflowXScroll}>
        <ContentHeader title={pageTitle}>
          <Input
            id="tech-radar-filter"
            type="search"
            placeholder="Filter"
            onChange={e => setSearchText(e.target.value)}
          />
          <SupportButton>
            This is used for visualizing the official guidelines of different
            areas of software development such as languages, frameworks,
            infrastructure and processes.
          </SupportButton>
        </ContentHeader>
        <Grid container spacing={3} direction="row">
          <Grid item xs={12} sm={6} md={4}>
            <FormControl>
              <InputLabel id="radar-select-label">Select Radar</InputLabel>
              <Select
                labelId="radar-select-label"
                value={radarId}
                onChange={(e) => setRadarId(e.target.value as string)}
              >
                <MenuItem value="Tranzact">Tranzact Technologies</MenuItem>
                {domains.map(domain => 
                  <MenuItem key={domain.metadata.name} value={domain.metadata.name}> {domain.metadata.name} </MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={3} direction="row">
          <Grid item xs={12} sm={6} md={4}>
          <TechRadarComponent id={radarId} {...componentProps} searchText={searchText}/>
          </Grid>
        </Grid>
      </Content>
    </Page>
    <div>
      
      <br/>
      
    </div>
    </>
  );
};

export default TechRadarCustomPage;